import type { ApiEvent } from '@api/events';

// The event's own logistics fields win over the linked `address` record: they
// are what the Edit Event form writes and what the quotation / delivery-order
// PDFs print, and a stale `address` renders a postal code that contradicts the
// placeholder highlight.
export function composeEventAddress(
  event: Pick<ApiEvent, 'venue_address' | 'venue_unit' | 'postal_code' | 'address'>,
): string {
  if (!event.venue_address) return event.address?.full_address ?? '';

  return [event.venue_address, event.venue_unit, event.postal_code].filter(Boolean).join(', ');
}
